<template>
    <div>
        <GChart
            type="ScatterChart"
            :settings="{packages: ['corechart'], language: 'pt-br'}"
            :data="chartDataFinal"
            :options="chartOptions"
        />
    </div>
</template>

<script>
export default {
    props: ['chartData', 'currency'],
    data() {
        return {
            chartOptions: {
                fontName: 'Muli',
                height: 450,
                legend: { position: 'top', maxLines: 3 },
                bar: { groupWidth: '75%' },
                isStacked: true,
                chartArea: {
                    width: '90%'
                },
                hAxis: {
                    title: this.__('reports.Date')
                },
                vAxis: {
                    title: this.__('reports.Result')
                },
                tooltip: {
                    isHtml: true
                }
            }
        }
    },
    computed: {
        chartDataFinal() {
            return this.chartData;
        }
    },
    created() {

        for (let i = 0; i < this.chartDataFinal.length; i++) {
            this.chartDataFinal[i][2] = this.customTooltip(this.chartDataFinal[i]);
        }

        this.chartDataFinal.unshift(['', this.__('reports.Result'), {type: 'string', role: 'tooltip', 'p': {'html': true}} ])
    },
    methods: {
        customTooltip(arr) {
            let result = null;
            if (arr[1] >= 0)
                result = "<div class='text-success'>" + this.currency + arr[1] + "</div>";
            else
                result = "<div class='text-danger'>" + this.currency + arr[1] + "</div>";

            return "<div class='scatter-tooltip p-1 text-center'>" + arr[2] + ' ' + arr[0] + '<br/>' + result + '</div>';
        }
    }
}
</script>

<style scoped>

</style>
